import type { AuthUser } from '@/types/auth';
import { isLeaderExperience, isSystemAdmin } from '@/constants/capabilities';

export const ROUTES = {
  login: '/login',
  admin: {
    root: '/admin',
    dashboard: '/admin/dashboard',
    departments: '/admin/departments',
    users: '/admin/users',
    reports: '/admin/reports',
    projects: '/admin/projects',
    projectCreate: '/admin/projects/create',
    projectDetail: (id: string) => `/admin/projects/${id}`,
    projectReports: '/admin/project-reports',
  },
  mobile: {
    leader: {
      root: '/m/leader',
      home: '/m/leader/home',
      team: '/m/leader/team',
      /** 领导班子监管日报（TOP / 班子成员） */
      leadership: '/m/leader/leadership',
      mine: '/m/leader/mine',
      /** 领导本人写日报 */
      myReport: '/m/leader/my-report',
      /** 查看下属日报详情：/m/leader/team/:reportId */
      teamReportDetail: (reportId: string) => `/m/leader/team/${reportId}`,
      history: '/m/leader/history',
      profile: '/m/leader/profile',
      password: '/m/leader/password',
      /** 任务中心：我的项目 */
      projects: '/m/leader/projects',
      projectDetail: (projectId: string) => `/m/leader/projects/${projectId}`,
      projectTaskDetail: (projectId: string, taskId: string) =>
        `/m/leader/projects/${projectId}/tasks/${taskId}`,
      /** @deprecated Lite 阶段重定向至写日报，保留路径仅作兼容跳转 */
      projectReportSubmit: (projectId: string) => `/m/leader/projects/${projectId}/reports/submit`,
      projectReportDetail: (projectId: string, reportId: string) =>
        `/m/leader/projects/${projectId}/reports/${reportId}`,
      notifications: '/m/leader/notifications',
      notificationDetail: (receiverId: string) => `/m/leader/notifications/${receiverId}`,
      /** @deprecated 使用 myReport */
      report: '/m/leader/my-report',
    },
    employee: {
      root: '/m/employee',
      home: '/m/employee/home',
      reports: '/m/employee/reports',
      tasks: '/m/employee/tasks',
      taskDetail: (taskId: string) => `/m/employee/tasks/${taskId}`,
      projects: '/m/employee/projects',
      projectDetail: (projectId: string) => `/m/employee/projects/${projectId}`,
      /** @deprecated Lite 阶段重定向至写日报，保留路径仅作兼容跳转 */
      projectReportSubmit: (projectId: string) =>
        `/m/employee/projects/${projectId}/reports/submit`,
      projectReportDetail: (projectId: string, reportId: string) =>
        `/m/employee/projects/${projectId}/reports/${reportId}`,
      notifications: '/m/employee/notifications',
      notificationDetail: (receiverId: string) => `/m/employee/notifications/${receiverId}`,
      mine: '/m/employee/mine',
      profile: '/m/employee/profile',
      leader: '/m/employee/leader',
      /** @deprecated */
      report: '/m/employee/report',
      history: '/m/employee/history',
    },
  },
  /** @deprecated 重定向至 /m */
  work: {
    root: '/work',
    reportSubmit: '/work/report',
    reportHistory: '/work/history',
    teamReports: '/work/team',
  },
  leader: {
    root: '/leader',
    reportSubmit: '/leader/report',
    reportHistory: '/leader/history',
    teamReports: '/leader/reports',
    leadershipReports: '/leader/leadership-reports',
  },
  employee: {
    root: '/employee',
    home: '/employee/home',
    reportSubmit: '/employee/report',
    reportHistory: '/employee/history',
  },
} as const;

/** 领导端移动路由辅助 */
export const leaderMobileRoutes = {
  team: ROUTES.mobile.leader.team,
  teamReport: ROUTES.mobile.leader.teamReportDetail,
  myReport: ROUTES.mobile.leader.myReport,
};

export function getHomePath(user: AuthUser): string {
  if (isSystemAdmin(user)) {
    return ROUTES.admin.dashboard;
  }

  if (isLeaderExperience(user)) {
    return ROUTES.mobile.leader.home;
  }

  return ROUTES.mobile.employee.home;
}
